import { Module } from 'vuex';
import { getters } from './getters';
import { actions } from './actions';
import { mutations } from './mutations';
import { GlobalState } from './types';
import { RootState } from '../types';

export const state: GlobalState = {
  clients: [],
};

export const global: Module<GlobalState, RootState> = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
